class AbnComponentController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        this.shouldShowValidation = false;
        this.isLoading = false;
        this.invalidErrorMessage = '';
        this.ABN = this.formValues.ABN;
    }

    onInputBlur() {
        this.shouldShowValidation = this.abnForm.ABN.$dirty;

        if (this.abnForm.$invalid) {
            delete this.formValues.ABN;
            delete this.formValues.EntityName;
        }
    }

    setLoadingStatus(status) {
        if (this.setLoading) {
            this.setLoading({ status: this.shouldShowValidation && status });
        }
    }

    getAbnResponse(res) {
        this.invalidErrorMessage = res.ErrorCode === 'Predicate'
            ? res.Message
            : this.settings.abnLookup.errorMessage;

        this.formValues.ABN = res.Success ? this.abnForm.ABN.$viewValue.replace(/[\s]+/g, '') : '';
        this.formValues.EntityName = res.Success ? res.EntityName : '';
    }
}

AbnComponentController.$inject = ['Settings'];

const AbnComponentDefinition = {
    bindings: {
        formValues: '<',
        classModifier: '@?',
        setLoading: '&?',
        shouldGrabFocus: '<?',
        hasSubmitted: '<?',
    },
    controller: AbnComponentController,
    template: require('./abn.component.html').trim(),
};

module.exports = {
    AbnComponentController,
    AbnComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/abn/abn.component.js